import {type ModalProps, message, Modal} from 'antd';
import {useForm} from 'form-render';
import Style from './index.module.scss';
import {useMutation, useQuery} from 'react-query';
import {isEmpty} from '../../../../../Stores/commonStore';
import useSchema from 'Utils/Hooks/useSchema';
import JsonForm from 'Components/JsonForm';
import {Agent} from '../../service';
import {useDictAll} from '../../../../../Utils/Hooks/useDict';

interface Props extends ModalProps {
    onOk: () => void;
    id?: string;
}

const Index = ({onOk, id, ...props}: Props) => {
    const form = useForm();

    const onSave = useMutation({
        mutationFn: Agent.save,
        onSuccess: () => {
            message.success('成功!');
            onOk();
        },
    });

    const getData = useQuery({
        queryKey: ['Agent.detail', id],
        enabled: !isEmpty(id),
        queryFn: () => Agent.detail(id!),
        onSuccess: res => {
            form.setValues(res);
        },
    });

    const dict = useDictAll(['Tenant']);

    const {schema} = useSchema({
        type: 'object',
        column: 2,
        displayType: 'row',
        labelWidth: 170,
        fieldCol: 14,
        properties: {
            name: {
                title: '名称',
                required: true,
                type: 'string',
            },
            code: {
                title: '编码',
                required: true,
                type: 'string',
                disabled: !isEmpty(id),
            },
            customerId: {
                title: '租户',
                required: true,
                type: 'string',
                widget: 'SelectDict',
                props: {
                    options: dict.Tenant.data,
                },
            },
            model: {
                type: 'string',
                title: '使用的模型',
                default: 'gpt-4',
            },
            description: {
                type: 'string',
                title: '描述',
                widget: 'textArea',
                column: 1,
            },
            systemPrompt: {
                type: 'string',
                title: '系统提示词',
                widget: 'textArea',
                column: 1,
            },
            temperature: {
                type: 'number',
                title: '温度参数',
                defaultValue: 0.7,
                props: {
                    step: 0.01,
                },
            },
            maxTokens: {
                type: 'number',
                title: '最大token数',
                defaultValue: 2000,
            },
            ragflowSimilarityThreshold: {
                type: 'number',
                title: 'RAGFlow相似度阈值',
                defaultValue: 0.4,
                props: {
                    min: 0,
                    max: 1,
                    step: 0.01,
                },
            },
            ragflowTopK: {
                type: 'number',
                title: 'RAGFlow返回结果数量',
                defaultValue: 3,
            },
            ragflowRerankId: {
                type: 'string',
                title: 'RAGFlow重排序模型ID',
            },
            ragflowUseKg: {
                type: 'boolean',
                title: '使用知识图谱',
                widget: 'switch',
                defaultValue: true,
            },
            status: {
                required: true,
                type: 'boolean',
                title: '启用',
                widget: 'switch',
                defaultValue: true,
            },
        },
    });

    function onFinish(formData: Agent.Form) {
        if (id) {
            formData.id = id;
        }
        onSave.mutate({...formData});
    }

    return (
        <Modal
            {...props}
            title={`${id ? '编辑' : '新增'}智能体`}
            width={1200}
            confirmLoading={onSave.isLoading || getData.isFetching}
            onOk={form.submit}>
            <div className={Style.root}>
                <JsonForm
                    loading={onSave.isLoading || getData.isFetching}
                    onFinish={onFinish}
                    schema={schema}
                    form={form}
                />
            </div>
        </Modal>
    );
};

export default Index;
